module.exports = __webpack_public_path__ + "img/invertercontrol.dd9f7053.svg";